"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dealerDistanceStyles_1 = require("./dealerDistanceStyles");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var useCurrentLocationPosition_1 = require("../../../../hooks/useCurrentLocationPosition");
var distance_1 = require("../../../../service/distance");
var geolocation_1 = require("../../../../constants/geolocation");
var DealerDistance = function (_a) {
    var dealer = _a.dealer;
    var styles = dealerDistanceStyles_1.default();
    var _b = useCurrentLocationPosition_1.default(), currentPosition = _b.currentPosition, error = _b.error;
    var getDistance = function (_a) {
        var latitude = _a.latitude, longitude = _a.longitude;
        if (dealer && currentPosition) {
            return distance_1.distance.calculateDistance(currentPosition, {
                latitude: latitude,
                longitude: longitude,
            });
        }
        return null;
    };
    return (<core_1.Box className={styles.dealerDistance} data-test={'text:dealer:distance'}>
      {currentPosition && (<>
          <core_1.Typography variant={'subtitle2'} component={'span'}>
            {(getDistance(dealer) / 1000).toFixed(2)}
          </core_1.Typography>
          <core_1.Typography variant={'subtitle2'} component={'span'} className={styles.dealerDistanceUnit}>
            <Translation_1.default id={'trans__checkout__dealers_page__distance_label'}/>
          </core_1.Typography>
        </>)}
      {error === geolocation_1.GEOLOCATION.NOT_SUPPORTED && (<core_1.Typography variant={'subtitle2'} component={'span'} className={styles.geoNotSupported}>
          <Translation_1.default id={'trans__checkout__dealers_page__geolocation_not_supported_message'}/>
        </core_1.Typography>)}
    </core_1.Box>);
};
exports.default = DealerDistance;
